export default {
  mainContainer: 'bg-color-bg w-[100%] min-h-screen',
  container: 'max-w-[1440px] mx-auto px-[5vw] lg:relative',
  section: 'py-[20px] flex flex-col items-center gap-[50px] sm:py-[50px] lg:py-[100px] lg:flex-row lg:gap-[20px]',
  content: 'lg:w-[50%] pt-28 sm:pt-0',
  text404: 'font-interSemibold text-[#EC6D25] text-[24px] leading-[29.05px]',
  title: 'font-interSemibold leading-[44px] text-[36px] text-color-text sm:leading-[58px] sm:text-[48px]',
  text: 'max-w-[446px] font-inter text-[16px] leading-[24px] text-[#404653] my-[28px] sm:text-[18px] sm:leading-[32px]',
  imageWrapper: 'sm:flex sm:align-center sm:justify-center lg:w-[50%]',
  image404: 'max-h-[400px]',
  button: 'max-w-[250px] bg-color-white',
  buttonText: 'font-interSemibold',
};
